import * as icons from './icons';

const createIconConfig = (src, size) => ({
	src,
	sizes: `${size}x${size}`,
	type: 'image/png',
	purpose: 'maskable any',
});

const createManifestConfig = ({ name, shortName, icons, themeColor, backgroundColor = '#ffffff' }) => ({
	name: `${name}`,
	short_name: shortName,
	icons: Object.entries(icons).map(([size, src]) => createIconConfig(src, size)),
	start_url: window.location.origin,
	display: 'fullscreen',
	theme_color: themeColor,
	background_color: backgroundColor,
});

export const manifestConfigs = {
	entekhab: createManifestConfig({
		name: 'Entekhabino app',
		shortName: `Entekhabino`,
		icons: icons.entekhabIcons,
		themeColor: '#5CC67C',
	}),

	keepa: createManifestConfig({
		name: 'Keepa app',
		shortName: `Keepa`,
		icons: icons.keepaIcons,
		theme_color: '#35306f',
	}),

	hamtaland: createManifestConfig({
		name: 'Hamtaland app',
		shortName: `Hamtaland`,
		icons: icons.hamtalandIcons,
		theme_color: '#ffffff',
	}),

	rayansaipa: createManifestConfig({
		name: 'Rayansaipa app',
		shortName: `Rayansaipa`,
		icons: icons.rayansaipaIcons,
		theme_color: '#ffffff',
	}),

	demo: createManifestConfig({
		name: 'Demo app',
		shortName: `Demo`,
		icons: icons.keepaIcons,
		theme_color: '#35306f',
	}),

	tisa: createManifestConfig({
		name: 'Tisa-pay app',
		shortName: `Tisapay`,
		icons: icons.tisaIcons,
		theme_color: '#3D85C6',
	}),

	saana: createManifestConfig({
		name: 'Saana-pay app',
		shortName: `Saana`,
		icons: icons.saanaIcons,
		theme_color: '#3D85C6',
	}),

	arbaeen: createManifestConfig({
		name: 'Arbaeen-pay app',
		shortName: `ArbaeenPay`,
		icons: icons.arbaeenIcons,
		theme_color: '#3D85C6',
	}),
};
